<template>
  <div v-if="visible" class="modal-overlay" @click="handleOverlayClick">
    <div style="background-color: #fff;">
      <div class="modal-container" @click.stop>
      <div class="modal-header">
        <span class="modal-title">温馨提示</span>
        <span class="close-btn" @click="close">×</span>
      </div>
      <div class="modal-body">
        <div class="icon-container">
          <div class="exclamation-icon">!</div>
        </div>
        <div class="message-text">
          <div></div>
          <div>敬请期待</div>
        </div>
      </div>
    </div>
    </div>
   
  </div>
</template>

<script>
export default {
  name: 'ComingSoonModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    handleOverlayClick() {
      this.close()
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  
  align-items: center;
  z-index: 9999;
}

.modal-container {
  width: 549.71px;
  height: 364.04px;
  background-color: #fff;
  overflow: hidden;
  position: relative;
}

.modal-header {
  background: linear-gradient(90deg, #1F67F0 -5%, #01A5FF 17%, rgba(1, 165, 255, 0) 100%);
  height: 50px;
  margin: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  position: relative;
}

.modal-title {
  color: #fff;
  font-size: 18px;
  font-weight: bold;
}

.close-btn {
  color: #000;
  font-size: 24px;
  font-weight: bold;
  cursor: pointer;
  line-height: 1;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transition: background 0.2s;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.3);
}

.modal-body {
  padding: 40px 20px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.icon-container {
  margin-bottom: 10px;
}

.exclamation-icon {
  width: 80px;
  height: 80px;
  background: #4d8aff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 48px;
  font-weight: bold;
  margin: 0 auto;
}

.message-text {
  color: #333;
  font-size: 16px;
  line-height: 1.6;
  text-align: center;
}

.message-text div {
  margin-bottom: 8px;
}

.message-text div:last-child {
  margin-bottom: 0;
}
</style>
